module.exports = __webpack_public_path__ + "img/emoticon-csat-3-on.2dc48034.svg";